import { createStore, combineReducers } from "redux";
import commonStore from "./common/reducer";

export const reducer = combineReducers({ commonStore });
export const store = createStore(reducer);

export default store;
